// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { TooltipFragmentDoc } from '../../../directives/tooltip/tooltip.generated';
export const PageTooltipFragmentDoc = gql`
    fragment pageTooltip on PageTooltip {
  triggerText
  tooltip {
    ...tooltip
  }
}
    ${TooltipFragmentDoc}`;